module.exports = __webpack_public_path__ + "img/2018-04-04 15.04.19.29032bfc.jpg";